export class Hierarchy<T>
{
    private _parsed: boolean = false;

    private _data: any[] = [];

    private _parsedData: any[] = [];

    private _idKey: string = 'id';

    private _parentKey: string = 'parent_id';

    private _root: number = 0;

    constructor(data: T[], idKey: Nullable<string> = null, parentKey: Nullable<string> = null, root: Nullable<number> = null)
    {
        this.setData(JSON.parse(JSON.stringify(data)));

        if (idKey)
        {
            this.setIdKey(idKey);
        }

        if (parentKey)
        {
            this.setParentKey(parentKey);
        }

        if (null !== root)
        {
            this.setRoot(root);
        }
    }

    public getArray(rebuild = false)
    {
        return this._parse(rebuild);
    }

    public sortArray(compareFn?: (a: T, b: T) => number): T[]
    {
        let array  = this._parse();
        const sort = (sortArray: any[]) =>
        {
            sortArray.sort(compareFn);
            for (let entry of sortArray)
            {
                if (entry.children)
                {
                    sort(entry.children);
                }
            }
        };
        sort(array);

        return array;
    }

    private _parse(rebuild = false): T[]
    {
        if (rebuild || !this.isParsed)
        {
            let node;
            let list  = this._data;
            let map   = {};
            // let roots = {};
            let roots = [];
            for (let i = 0; i < list.length; i += 1)
            {
                map[list[i][this._idKey]] = i; // initialize the map
                // list[i].children          = {}; // initialize the children
                list[i].children = []; // initialize the children
            }
            for (let i = 0; i < list.length; i += 1)
            {
                node = list[i];
                if (node[this._parentKey] !== this._root)
                {
                    // if you have dangling branches check that map[node.parentId] exists
                    list[map[node[this._parentKey]]].children.push(node);
                    // list[map[node[this._parentKey]]].children[node[this._idKey]] = node;
                }
                else
                {
                    roots.push(node);
                    // roots[node[this._idKey]] = node;
                }
            }
            this._parsedData = roots;
        }

        return this.parsedData;
    }

    //<editor-fold desc="setter/getter">
    get parsedData()
    {
        return this._parsedData;
    }

    get isParsed()
    {
        return this._parsed;
    }

    set isParsed(newValue: boolean)
    {
        this._parsed = newValue;
    }

    setData(data: any[])
    {
        this.isParsed = false;
        this._data    = data;
    }

    setIdKey(idKey: string)
    {
        this.isParsed = false;
        this._idKey   = idKey;
    }

    setParentKey(parentKey: string)
    {
        this.isParsed   = false;
        this._parentKey = parentKey;
    }

    setRoot(root: number)
    {
        this.isParsed = false;
        this._root    = root;
    }

    //</editor-fold>
}